/* Robotow kit buy box. Port of the prototype's kit.js (corrected copy), on Shopify variants.
   - The airplane comes from the fit finder (?ac= deep link or a search), follow-up asked first.
   - The kit variant is found by SKU: <series><battery>-<adapter sku>, series 65 standard, 66 Pro, 67 SF.
   - Add to cart exists only for a fit, and only for a real variant. One /cart/add.js call, items array.
   - The sticky bar prints what Fit.classify() says, nothing else. */
(function () {
  "use strict";

  var root = document.querySelector("[data-rt-kit]");
  if (!root) return;
  var Fit = window.RobotowFit;
  var DATA = JSON.parse(root.querySelector("[data-kit-data]").textContent);
  var bySku = {}, byId = {};
  DATA.variants.forEach(function (v) { if (v.sku) bySku[v.sku] = v; byId[String(v.id)] = v; });

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var money = function (c) { return Fit ? Fit.money(c) : "$" + (c / 100); };
  var esc = function (t) { return Fit ? Fit.esc(t) : String(t); };

  // On the Complete kit's own URL the buy box opens on Complete (until the visitor picks another frame).
  var wantComplete = DATA.preselect === "complete";
  var state = { aircraft: null, frame: wantComplete ? "complete" : "standard", battery: wantComplete ? "8Ah" : "5Ah", addons: [], lock: null };
  var cfg = function () { return Fit.config() || {}; };

  function track(name, params) { if (typeof window.rtTrack === "function") window.rtTrack(name, params); }

  /* ---------- the model ---------- */
  function adapter() { return state.aircraft ? Fit.getAdapter(state.aircraft.adapter) : null; }
  function classify() { return state.aircraft ? Fit.classify(state.aircraft) : "none"; }
  function requiredFrame() {
    var a = state.aircraft;
    if (!a) return state.lock ? state.lock.required : null;
    if (a.unit === "6600") return "pro";
    if (a.unit === "6700") return "sf";
    return null;
  }
  var SERIES = { standard: "65", pro: "66", sf: "67" };
  function adapterCode() {
    var ad = adapter();
    return ad ? (ad.sku || ad.pn) : state.lock ? state.lock.adapter : null;
  }
  function skuFor(frame, battery) {
    var code = adapterCode();
    if (!code || !SERIES[frame]) return null;
    return SERIES[frame] + (battery === "8Ah" ? "08" : "05") + "-" + code;
  }
  function lockFrom(id) {
    var v = byId[String(id)], match = v && /^(6[567])(05|08)-(.+)$/.exec(v.sku || "");
    if (!match) return null;
    var frame = match[1] === "65" ? "standard" : match[1] === "66" ? "pro" : "sf";
    return { adapter: match[3], frame: frame, battery: match[2] === "08" ? "8Ah" : "5Ah",
      required: bySku["6505-" + match[3]] ? null : frame };
  }
  function kitVariant(frame, battery) {
    var sku = skuFor(frame, battery);
    return sku ? bySku[sku] || null : null;
  }
  function completeVariant() {
    var ad = adapter();
    if (!ad || !DATA.complete || !DATA.complete.length) return null;
    if (state.aircraft.unit === "6700") return null;
    var code = "-" + (ad.sku || ad.pn);
    for (var i = 0; i < DATA.complete.length; i++) {
      var v = DATA.complete[i];
      if (v.sku && v.sku.slice(-code.length) === code) return v;
    }
    return null;
  }
  // "The same parts sell for $X separately": only when every part is a real variant for this airplane
  // (the Pro 8Ah kit is the frame, battery, charger and adapter; plus the Dolly Wheel), from live prices.
  function separatePrice() {
    var comp = completeVariant(), parts = kitVariant("pro", "8Ah");
    if (!state.aircraft || !comp || !parts || !DATA.dolly || DATA.dolly.price == null) return null;
    var sum = parts.price + DATA.dolly.price;
    return sum > comp.price ? sum : null;
  }
  function isDolly(input) { return !!(DATA.dolly && input.getAttribute("data-handle") === DATA.dolly.handle); }
  function syncAddons() {
    state.addons = $$('input[name="rt-addon"]:checked').filter(function (i) { return !i.disabled; }).map(function (i) {
      return { id: Number(i.value), price: Number(i.getAttribute("data-price")), title: i.getAttribute("data-title"), dolly: isDolly(i) };
    });
    $$(".rt-opt--check").forEach(function (l) { l.classList.toggle("is-selected", l.querySelector("input").checked); });
  }
  // A Pro frame on a standard-fit airplane has no sellable variant yet.
  function proByPhone() {
    return state.aircraft && !requiredFrame() && state.frame === "pro" && !kitVariant("pro", state.battery);
  }
  function currentVariant() {
    if (state.frame === "complete") return completeVariant();
    return kitVariant(state.frame, state.battery);
  }
  function currentKitPrice() {
    var v = currentVariant();
    return v ? v.price : null;
  }
  function addonsTotal() {
    return state.addons.reduce(function (t, a) { return t + a.price; }, 0);
  }

  /* ---------- rendering ---------- */
  function fitLineHTML() {
    var a = state.aircraft, c = classify(), ad = adapter();
    if (!a) return "";
    var frame = requiredFrame();
    var frameName = frame === "pro" ? "Pro" : frame === "sf" ? "SF" : "standard";
    var head, body;
    if (c === "fits") {
      head = Fit.glyph("yes") + "<span>Fits.</span>";
      body = "Your " + esc(a.display) + " takes the " + esc(ad ? ad.name : "matching adapter") + " on the standard frame. The adapter is in this kit.";
    } else if (c === "confirm-proSF") {
      head = Fit.glyph("yes") + "<span>Fits with the " + frameName + " frame, confirm with us.</span>";
      body = "Your " + esc(a.display) + " takes the " + esc(ad ? ad.name : "matching adapter") + " on the " + frameName +
        " frame. The adapter is in this kit. Call us and we will confirm the fit before it ships.";
    } else if (c === "confirm-unconfirmed") {
      head = Fit.glyph("ask") + "<span>Confirm with us.</span>";
      body = "We have not confirmed the " + esc(a.display) + " yet. Send two photos of the nose gear and we will tell you if it fits.";
    } else {
      head = Fit.glyph("no") + "<span>Does not fit.</span>";
      body = esc(a.fit_note || (a.display + " is not on the fit list.")) + " Better you hear it from us now than after it ships.";
    }
    return '<div class="rt-kit-answer is-' + (c === "fits" || c === "confirm-proSF" ? "fits" : c === "nofit" ? "no" : "ask") + '">' +
      '<p class="rt-kit-answer-line">' + head + "</p>" +
      "<p>" + body + "</p>" +
      '<button type="button" class="rt-link-btn" data-kit-change>Change airplane</button></div>';
  }

  function renderFit() {
    var line = $("[data-kit-fitline]"), finder = $("[data-kit-finder]");
    line.innerHTML = fitLineHTML();
    finder.hidden = !!state.aircraft;
    var ch = line.querySelector("[data-kit-change]");
    if (ch) ch.addEventListener("click", function () {
      setAircraft(null);
      var input = root.querySelector("#kit-finder-input");
      if (input) { input.value = ""; input.focus(); }
    });
  }

  function setOption(frame, opts) {
    var label = root.querySelector('[data-frame-opt="' + frame + '"]');
    if (!label) return;
    var input = label.querySelector("input");
    label.hidden = !!opts.hidden;
    input.disabled = !!opts.disabled;
    label.classList.toggle("is-locked", !!opts.disabled);
    var lock = root.querySelector('[data-frame-lock="' + frame + '"]');
    if (lock) { lock.hidden = !opts.lock; lock.textContent = opts.lock || ""; }
    var price = root.querySelector('[data-frame-price="' + frame + '"]');
    if (price) price.textContent = opts.price || "";
  }

  function renderOptions() {
    var a = state.aircraft, req = requiredFrame(), c = classify();
    var bat = state.battery;
    var std = kitVariant("standard", bat), pro = kitVariant("pro", bat), sf = kitVariant("sf", bat), comp = completeVariant();
    var name = a ? esc(a.display) : "";
    if (!a && !state.lock) {
      setOption("standard", { price: "" });
      setOption("pro", { price: "" });
      setOption("sf", { hidden: true });
      setOption("complete", { price: "" });
    } else if (req === "pro") {
      setOption("standard", { disabled: true, lock: a ? "The standard frame does not fit your " + a.display + "." : "This adapter is made for the Pro frame." });
      setOption("pro", { price: pro ? money(pro.price) : "" });
      setOption("sf", { hidden: true });
    } else if (req === "sf") {
      setOption("standard", { disabled: true, hidden: false, lock: a ? "Your " + a.display + " takes the SF frame. No other frame fits it." : "This adapter is made for the SF frame. No other frame fits it." });
      setOption("pro", { disabled: true, lock: a ? "Your " + a.display + " takes the SF frame. No other frame fits it." : "This adapter is made for the SF frame. No other frame fits it." });
      setOption("sf", { hidden: false, price: sf ? money(sf.price) : "" });
    } else {
      setOption("standard", { price: std ? money(std.price) : "" });
      setOption("pro", {
        disabled: !a && !pro,
        price: pro ? money(pro.price) : "",
        lock: pro ? "" : a ? "Order the Pro frame for this airplane by phone." : "Choose an airplane to confirm Pro availability."
      });
      setOption("sf", { hidden: true });
    }
    if (root.querySelector('[data-frame-opt="complete"]')) {
      setOption("complete", {
        hidden: !!(a && req === "sf"),
        disabled: !!(a && !comp),
        price: comp ? money(comp.price) : "",
        lock: a && !comp && req !== "sf" ? "Not offered for this airplane yet." : ""
      });
      var sepEl = root.querySelector("[data-complete-separately]"), sep = separatePrice();
      if (sepEl) { sepEl.hidden = sep == null; sepEl.textContent = sep == null ? "" : "The same parts sell for " + money(sep) + " separately."; }
    }
    // keep the chosen frame legal
    if (state.frame === "complete" && a && !comp) state.frame = req || "standard";
    if (req === "pro") state.frame = state.frame === "complete" && comp ? "complete" : "pro";
    if (req === "sf") state.frame = "sf";
    if (!req && state.frame === "sf") state.frame = "standard";
    $$('input[name="rt-frame"]').forEach(function (i) { i.checked = i.value === state.frame; });
    // battery rows: Complete includes the 8Ah
    var batWrap = $("[data-kit-batteries]");
    batWrap.hidden = state.frame === "complete";
    var frameForBat = state.frame === "complete" ? "pro" : state.frame;
    ["5Ah", "8Ah"].forEach(function (b) {
      var v = kitVariant(frameForBat, b);
      var el = root.querySelector('[data-battery-price="' + b + '"]');
      if (!el) return;
      if (!a && !state.lock) el.textContent = "";
      else if (v) el.textContent = money(v.price);
      else el.textContent = "";
    });
    $$('input[name="rt-battery"]').forEach(function (i) { i.checked = i.value === state.battery; });
    // the Dolly Wheel is in the Complete box: its add-on hides and leaves the cart payload
    var inBox = state.frame === "complete";
    $$('input[name="rt-addon"]').forEach(function (i) {
      if (!isDolly(i)) return;
      if (inBox) i.checked = false;
      i.disabled = inBox;
      var l = i.closest(".rt-opt"); if (l) l.hidden = inBox;
    });
    // NEWOWNER: the free 5Ah battery is the same variant as the paid 5Ah add-on, so hide that row while the offer is on
    // (the offer buys product robotow-2-0-kit only, so the Complete frame never counts)
    var offerNow = offerOn && !inBox;
    $$('input[name="rt-addon"]').forEach(function (i) {
      if (!FREE_BATTERY || Number(i.value) !== FREE_BATTERY.variantId) return;
      if (offerNow) i.checked = false;
      i.disabled = offerNow || (isDolly(i) && inBox);
      var l = i.closest(".rt-opt"); if (l) l.hidden = offerNow;
    });
    syncAddons();
    $$(".rt-opt").forEach(function (l) {
      var i = l.querySelector("input");
      l.classList.toggle("is-selected", !!(i && i.checked));
    });
  }

  function ctaState() {
    var a = state.aircraft, c = classify(), v = currentVariant();
    var phone = cfg().phoneDisplay || "";
    var tel = "tel:" + (cfg().phoneTel || "");
    if (!a) return { mode: "ask", label: "Tell us what you fly first" };
    if (c === "nofit") return { mode: "link", label: "See what does fit", href: DATA.fitListPath || "/" };
    if (c === "confirm-unconfirmed") {
      return { mode: "link", label: "Send photos of my nose gear", href: (DATA.contactPath || "/pages/contact") + "?airplane=" + encodeURIComponent(a.display) + "&ac=" + encodeURIComponent(a.id) };
    }
    if (proByPhone()) return { mode: "link", label: "Call " + phone + " to order the Pro frame", href: tel, phone: true };
    if (!v) return { mode: "link", label: "Call " + phone + " to order this kit", href: tel, phone: true };
    if (!v.available) return { mode: "link", label: "Out of stock right now: call " + phone, href: tel, phone: true };
    var total = v.price + addonsTotal();
    return { mode: "add", label: "Add my kit to the cart · " + money(total) };
  }

  function renderTotal() {
    var a = state.aircraft, v = currentVariant(), kp = currentKitPrice();
    var priceEl = $("[data-kit-price]"), noteEl = $("[data-kit-price-note]");
    var totalEl = $("[data-kit-total]"), skuEl = $("[data-kit-sku]"), incEl = $("[data-kit-includes]");
    if (a && proByPhone() && classify() === "fits") {
      var ph = cfg().phoneDisplay;
      priceEl.textContent = "Price by phone";
      noteEl.textContent = "";
      totalEl.textContent = "Pro frame for your " + a.display + ": call " + (ph || "us") + " for the price.";
      skuEl.textContent = "";
      incEl.hidden = true;
    } else if (kp == null) {
      priceEl.textContent = "From " + money(DATA.fromPrice);
      noteEl.textContent = DATA.priceNote || "";
      totalEl.textContent = a ? "" : "Your total shows here once we know your airplane.";
      skuEl.textContent = "";
      incEl.hidden = true;
    } else {
      var total = kp + addonsTotal();
      var priceText = money(kp);
      var frameWord = state.frame === "sf" ? "SF" : state.frame === "pro" ? "Pro" : "standard";
      var noteText = state.frame === "complete" ? "Complete kit for your " + a.display + "." : a ?
        "Robotow 2.0 Kit for your " + a.display + ", " + frameWord + " frame, " + state.battery + " battery." :
        "Robotow 2.0 Kit with the " + (v ? v.title.split(" / ")[0] : "") + " adapter, " + frameWord + " frame, " + state.battery + " battery.";
      if (v && !v.available) noteText += " Out of stock right now.";
      if (priceEl.textContent !== priceText) priceEl.textContent = priceText;
      if (noteEl.textContent !== noteText) noteEl.textContent = noteText;
      totalEl.innerHTML = "Total <span class=\"rt-num\">" + money(total) + "</span>" +
        (state.addons.length ? ' <span class="rt-kit-total-parts">kit ' + money(kp) + " + " + state.addons.map(function (x) { return esc(x.title) + " " + money(x.price); }).join(" + ") + "</span>" : "");
      var sku = state.frame === "complete" ? (v ? v.sku : "") : skuFor(state.frame, state.battery);
      skuEl.textContent = sku ? "Part number " + sku : "";
      if (v && v.includes) { incEl.hidden = false; incEl.textContent = "In the box: " + v.includes; }
      else incEl.hidden = true;
    }
    // Shop Pay Installments follows the kit variant (Shopify renders its own figure and terms)
    var inst = $("[data-kit-installments]");
    if (inst) {
      var ok = !!(v && v.available && (classify() === "fits" || classify() === "confirm-proSF"));
      inst.hidden = !ok;
      if (ok) {
        var idInput = inst.querySelector("[data-kit-installments-id]");
        if (idInput && String(idInput.value) !== String(v.id)) {
          idInput.value = v.id;
          idInput.dispatchEvent(new Event("change", { bubbles: true }));
          var pt = inst.querySelector("shopify-payment-terms");
          if (pt) pt.setAttribute("variant-id", v.id);
        }
      }
    }
    // the button
    var cta = ctaState();
    var add = $("[data-kit-add]"), alt = $("[data-kit-alt]");
    if (cta.mode === "add" || cta.mode === "ask") {
      add.hidden = false; alt.hidden = true;
      add.textContent = adding ? "Adding your kit..." : cta.label;
      add.setAttribute("data-mode", cta.mode);
    } else {
      add.hidden = true; alt.hidden = false;
      alt.textContent = cta.label;
      alt.setAttribute("href", cta.href);
      if (cta.phone) alt.setAttribute("data-rt-phone-location", "buy_box"); else alt.removeAttribute("data-rt-phone-location");
    }
    renderSticky(cta);
    renderOffer();
  }

  function renderSticky(cta) {
    var a = state.aircraft, c = classify();
    var fitEl = $("[data-sticky-fit]"), priceEl = $("[data-sticky-price]"), btn = $("[data-sticky-cta]");
    // Compliance 7.1: the bar says exactly what the buy box says.
    if (!a) fitEl.textContent = "What do you fly?";
    else if (c === "fits" || c === "confirm-proSF") fitEl.textContent = "Fits your " + a.display + ".";
    else if (c === "confirm-unconfirmed") fitEl.textContent = "Confirm with us: " + a.display + ".";
    else fitEl.textContent = "Does not fit your " + a.display + ".";
    var kp = currentKitPrice();
    priceEl.textContent = a && kp != null && (c === "fits" || c === "confirm-proSF") ? money(kp + addonsTotal()) : "";
    btn.textContent = cta.mode === "add" ? "Add my kit to the cart" : cta.mode === "ask" ? "Check my airplane" : cta.label;
  }

  function renderAll() { renderFit(); renderOptions(); renderTotal(); }

  function setAircraft(a) {
    var oldLock = state.lock;
    state.aircraft = a;
    var req = requiredFrame();
    if (!a || !oldLock || a.adapter !== oldLock.adapter || (req && state.frame !== req) || (!req && state.frame === "sf")) {
      state.frame = req || "standard";
    }
    state.lock = null;
    if (wantComplete && req !== "sf" && (!a || completeVariant())) { state.frame = "complete"; state.battery = "8Ah"; }
    syncUrl();
    renderAll();
  }

  function syncUrl() {
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (state.aircraft) url.searchParams.set("ac", state.aircraft.id); else url.searchParams.delete("ac");
      var v = state.frame === "complete" ? null : currentVariant();
      if (v) { url.searchParams.set("variant", v.id); url.searchParams.delete("battery"); }
      else url.searchParams.delete("variant");
      var path = url.pathname + url.search + url.hash;
      if (path !== window.location.pathname + window.location.search + window.location.hash) window.history.replaceState(null, "", path);
    }
  }

  /* ---------- events ---------- */
  root.addEventListener("rt:aircraft", function (e) { setAircraft(e.detail.aircraft); });

  root.addEventListener("change", function (e) {
    var t = e.target;
    if (t.name === "rt-frame" && !t.disabled) {
      state.frame = t.value;
      wantComplete = false;
      if (t.value === "complete") state.battery = "8Ah";
      renderOptions(); renderTotal(); syncUrl(); frameEvent();
    } else if (t.name === "rt-battery") {
      state.battery = t.value; renderOptions(); renderTotal(); syncUrl(); frameEvent();
    } else if (t.name === "rt-addon") {
      syncAddons();
      renderTotal();
    }
  });

  function frameEvent() {
    var kp = currentKitPrice();
    track("rt_frame_selected", {
      aircraft_id: state.aircraft ? state.aircraft.id : "",
      frame: state.frame, battery: state.battery.toLowerCase(),
      kit_price: kp != null ? kp / 100 : null, entry_point: "kit_buybox"
    });
  }

  function focusFinder() {
    var input = root.querySelector("#kit-finder-input");
    if (input) { input.scrollIntoView({ block: "center" }); input.focus({ preventScroll: true }); }
  }

  /* ---------- NEWOWNER: the free 5Ah battery rides along when the code is on the cart ---------- */
  /* Offer end 2027-03-31 23:59:59 ET; keep identical in assets/rt-site.js and assets/rt-cart.js */
  var FREE_BATTERY = { code: "NEWOWNER", variantId: 67628203147418, until: Date.parse("2027-04-01T03:59:59Z") };
  var offerOn = false, adding = false, loadOk = false;
  function readCart(ms) {
    var ctl = ms && typeof AbortController === "function" ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : null;
    var opts = { credentials: "same-origin", headers: { Accept: "application/json" } };
    if (ctl) opts.signal = ctl.signal;
    return fetch("/cart.js", opts).then(function (r) { return r.json(); })
      .then(function (j) { if (timer) clearTimeout(timer); return j; }, function (e) { if (timer) clearTimeout(timer); throw e; });
  }
  function lineQty(cart, id) {
    return (cart.items || []).reduce(function (n, i) { return Number(i.variant_id) === Number(id) ? n + Number(i.quantity || 0) : n; }, 0);
  }
  function cartHasOffer(cart) {
    return (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === FREE_BATTERY.code; });
  }
  function cartHasBattery(cart) {
    return (cart.items || []).some(function (i) { return Number(i.variant_id) === FREE_BATTERY.variantId; });
  }
  function renderOffer() {
    var el = $(".rt-kit-offer");
    if (!el) return;
    var add = $("[data-kit-add]");
    el.hidden = !(offerOn && state.frame !== "complete" && add && !add.hidden && add.getAttribute("data-mode") === "add");
  }
  try {
    if (Date.now() < FREE_BATTERY.until) {
      readCart().then(function (cart) {
        loadOk = true;
        offerOn = cartHasOffer(cart) && !cartHasBattery(cart);
        renderOptions(); renderTotal();
      }).catch(function () {});
    }
  } catch (e) {}

  function addToCart() {
    var add = $("[data-kit-add]"), err = $("[data-kit-error]");
    if (adding || add.disabled) return;
    if (add.getAttribute("data-mode") !== "add") { focusFinder(); return; }
    var v = currentVariant(), a = state.aircraft;
    if (!v || !a) return;
    var items = [{ id: v.id, quantity: 1, properties: { Airplane: a.display } }];
    state.addons.forEach(function (x) {
      if (x.dolly && state.frame === "complete") return; // already in the Complete box
      items.push({ id: x.id, quantity: 1 });
    });
    adding = true;
    add.disabled = true;
    add.textContent = "Adding your kit...";
    err.textContent = "";
    function post(list) {
      return fetch(DATA.cartAddUrl, {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: list })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add the kit."); return j; });
      });
    }
    // NEWOWNER: if the code is on the cart, add the free battery with the kit. Never blocks the kit sale.
    var withOffer = Promise.resolve(null), before = 0;
    // read the cart at click when the offer is on, or when the page-load read has not come back OK yet (early click or failed read)
    if ((offerOn || !loadOk) && Date.now() < FREE_BATTERY.until && byId[String(v.id)]) {
      withOffer = readCart(3000).then(function (cart) {
        before = lineQty(cart, v.id);
        var inItems = items.some(function (x) { return Number(x.id) === FREE_BATTERY.variantId; });
        if (!cartHasOffer(cart) || cartHasBattery(cart) || inItems) return null;
        return items.concat([{ id: FREE_BATTERY.variantId, quantity: 1 }]);
      }).catch(function () { return null; });
    }
    withOffer.then(function (extra) {
      if (!extra) return post(items);
      return post(extra).catch(function (postErr) {
        // re-read the cart: only retry kit-only if the failed request did not already add the kit
        return readCart(3000).then(function (c) {
          // skip only if THIS click already added the kit (quantity went up from the cart read before the add)
          return lineQty(c, v.id) > before ? null : post(items);
        }, function () { throw postErr; }); // re-read failed: show the original add error, not the abort text
      });
    }).then(function () {
      window.location.href = DATA.cartUrl;
    }).catch(function (e) {
      adding = false;
      add.disabled = false;
      renderTotal();
      err.textContent = "We could not add the kit to the cart: " + e.message + " Call " + (cfg().phoneDisplay || "") + " and we will take the order.";
    });
  }
  $("[data-kit-add]").addEventListener("click", addToCart);
  // Back from the cart can restore this page from bfcache with the add lock still set
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    adding = false;
    var b = $("[data-kit-add]"); if (b) b.disabled = false;
    try { renderTotal(); } catch (x) {}
    try {
      readCart(3000).then(function (c) {
        loadOk = true;
        offerOn = Date.now() < FREE_BATTERY.until && cartHasOffer(c) && !cartHasBattery(c);
        renderOptions(); renderTotal();
      }).catch(function () { renderOptions(); renderTotal(); });
    } catch (x) {}
  });

  /* ---------- sticky bar: engages when the buy button leaves the screen ---------- */
  var sticky = $("[data-kit-sticky]");
  $("[data-sticky-cta]").addEventListener("click", function () {
    var mode = $("[data-kit-add]").getAttribute("data-mode");
    if (!state.aircraft || mode === "ask") { focusFinder(); return; }
    if (!$("[data-kit-add]").hidden) { addToCart(); return; }
    var alt = $("[data-kit-alt]");
    if (alt && alt.getAttribute("href")) window.location.href = alt.getAttribute("href");
  });
  // Shown once the buy button has scrolled above the screen. Checked on scroll (rAF-throttled),
  // because an observer does not fire when a jump skips straight past the button.
  var target = $("[data-kit-cta]"), ticking = false;
  function checkSticky() {
    ticking = false;
    var r = target.getBoundingClientRect();
    var show = r.bottom < 0;
    if (sticky.hidden === !show) return;
    sticky.hidden = !show;
    document.documentElement.style.scrollPaddingBottom = show ? sticky.offsetHeight + 12 + "px" : "";
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); } }
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("scroll", onScroll, { passive: true, capture: true });
  window.addEventListener("resize", onScroll, { passive: true });

  /* ---------- start ---------- */
  var bp = new URLSearchParams(window.location.search).get("battery");
  if (bp === "8Ah" || bp === "5Ah") state.battery = bp;
  state.lock = DATA.selected ? lockFrom(DATA.selected) : null;
  if (state.lock) { state.frame = state.lock.frame; state.battery = state.lock.battery; }
  if (Fit) Fit.ready(function () { renderAll(); });
  renderOptions(); renderTotal();
})();
